














































































































































































































































import Currency from '@/components/Currency.vue';
import Cantidad from '@/components/Cantidad.vue';
export default {
	components: { Cantidad, Currency },
	name: 'carritoOrdenes',
	inject: ['responsive'],
	props: {
		visible: {
			type: Boolean,
			required: true,
			default: false,
		},
		cardactivo: {
			type: Number,
		},
	},
	data() {
		return {
			pickerOptions: {
				disabledDate: this.disabledDate,
			},
			showAlertPrecio: false,
			alertaPrecio: [],
			visibleCarrito: false,
			show: false,
			activo: 1,
			loading: false,
			loadingConfirm: false,
			loadingCondiciones: false,
			input: '',
			form: {
				cpago: '',
				fecha_entrega: null,
				detalle: '.',
				conimpuesto: null,
			},
			rules: {
				cpago: [{ required: true, message: 'Ingresar condicion de pago' }],
			},
		};
	},
	watch: {
		visible(v) {
			this.show = !this.show;
		},
		cardactivo(v) {
			this.activo = v;
		},
		// carrito(v) {
		// 	if (v) this.loading = false;
		// },
	},
	computed: {
		producto() {
			return this.$store.state.ordenescompra.filter((ele: { id: string }) => ele.id == this.$route.path.slice(13))[0];
		},
		cpago: {
			get() {
				return this.form.cpago === '' ? this.$store.state.ordenescompra.cpago : this.form.cpago;
			},
			set(val) {
				this.form.cpago = val;
			},
		},
		fecha_entrega: {
			get() {
				return this.form.fecha_entrega === null ? this.$store.state.ordenescompra.fecha_entrega : this.form.fecha_entrega;
			},
			set(val) {
				this.form.fecha_entrega = val;
			},
		},
		carrito() {
			return this.$store.state.ordenescompra.carrito;
		},
		/*loading: {
			get() {
				return this.$store.state.ordenescompra.loadingcarrito;
			},
			set(val) {
				this.$store.state.ordenescompra.loadingcarrito = val;
			},
		},*/
		idcarrito() {
			return this.$store.state.ordenescompra.idcarrito;
		},
		torigen() {
			return this.$store.state.ordenescompra.torigen;
		},
		cpagos() {
			return this.$store.state.ordenescompra.cpagos;
		},
		fdepagos() {
			return this.$store.state.ordenescompra.fdepagos;
		},
		total() {
			return this.$store.state.ordenescompra.totalpedido;
		},
		importes() {
			return this.$store.state.ordenescompra.importes;
		},
		activeHost() {
			return this.$store.state.perfil.activeHost;
		},
		cooperativa() {
			return this.$store.state.config.cuit;
		},
		detallepedido: {
			get() {
				return this.form.detalle === '.' ? this.$store.state.ordenescompra.detallepedido : this.form.detalle;
			},
			set(val) {
				this.form.detalle = val;
			},
		},
		conimpuesto: {
			get() {
				return this.form.conimpuesto === null ? this.$store.state.ordenescompra.conimpuesto : this.form.conimpuesto;
			},
			set(val) {
				this.form.conimpuesto = val;
			},
		},
		totales() {
			return this.$store.state.ordenescompra.totales;
		},
	},
	methods: {
		disabledDate(time: Date) {
			const date = new Date();
			return time.getTime() < date.getTime() + 3600 * 1000 * 24 * this.diasEntrega;
		},
		updateDetalle(valor = false) {
			let condiciones = [];
			condiciones['detalle'] = this.detallepedido;
			condiciones['pedido_id'] = this.idcarrito;
			this.$store.dispatch('putDetalleOrdenes', condiciones);
		},
		loadSelect(event: boolean) {
			if (event) this.$store.dispatch('loadCpagos').then(() => {});
		},
		clearEntrega() {
			this.form.entrega = '';
			this.updateCondicion();
		},
		updateCondicion(cpago: number) {
			let condiciones = [];
			condiciones['cpago'] = cpago ? cpago : this.form.cpago;
			condiciones['pedido_id'] = this.idcarrito;
			this.$store.dispatch('putCpagoOrdenes', condiciones);
		},
		updateFecha() {
			let condiciones = [];
			condiciones['fecha_entrega'] = this.form.fecha_entrega;
			condiciones['pedido_id'] = this.idcarrito;
			this.$store.dispatch('putFechaEntregaOrden', condiciones);
		},
		updateImpuesto() {
			let condiciones = [];
			condiciones['conimpuesto'] = this.form.conimpuesto;
			condiciones['pedido_id'] = this.idcarrito;
			this.$store.dispatch('putConImpuestoOrden', condiciones);
		},
		getEmpty() {},
		removeProducto(producto: { pk: number; ocompra_id: number }) {
			let params = {
				params: {
					id: producto.pk,
					ocompra_id: producto.ocompra_id,
				},
			};

			this.$confirm('El producto será eliminado del carrito. ¿Desea continuar?', 'Confirmación', {
				confirmButtonText: 'Si',
				cancelButtonText: 'Cancelar',
				type: 'warning',
				center: true,
			})
				.then(() => {
					this.loading = true;
					this.$store.dispatch('removeProductoOrden', params).then(() => (this.loading = false));
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: 'Operación cancelada',
					});
				});
		},
		removeAll() {
			this.alertaPrecio = [];
			let params = {
				params: {
					ocompra_id: this.idcarrito,
				},
			};

			this.$confirm('Se eliminarán todo los productos y condiciones cargadas. ¿Desea continuar?', 'Confirmación', {
				confirmButtonText: 'Si',
				cancelButtonText: 'Cancelar',
				type: 'warning',
				center: true,
			})
				.then(() => {
					this.loading = true;
					this.fecha_entrega = '';
					this.entrega = '';
					this.origen = '';
					this.detallepedido = '';
					this.$store.dispatch('removeAllOrden', params).then(() => (this.loading = false));
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: 'Operación cancelada',
					});
				});
		},
		onClosed() {
			this.show = false;
		},
		onOpen() {
			this.loadingCondiciones = false;
			/*this.$store.dispatch('loadDentregas').then(entrega => {
				if (entrega.length === 1) {
					this.form.entrega = entrega[0].destino_id;
					this.updateEntrega(entrega[0].destino_id);
				}
				this.loadingCondiciones = false;
			});*/
		},
		handleClick() {
			this.activo = ++this.activo;
		},
		handleBack() {
			this.activo = --this.activo;
		},
		handleConfirm() {
			this.$confirm('Su Orden de compra será confirmado. ¿Desea continuar?', 'Confirmación', {
				confirmButtonText: 'Si',
				cancelButtonText: 'Cancelar',
				type: 'warning',
				center: true,
			})
				.then(() => {
					this.loadingConfirm = true;
					this.$store.dispatch('confirmOcompra', this.idcarrito).then(result => {
						if (result.status === 200) {
							if (result.data.success) {
								this.$store.state.ordenescompra.carrito = [];
								this.form.cpago = '';
								this.form.detalle = '';
								this.form.fecha_entrega = '';
								this.show = false;
								this.activo = 1;
								this.$message({
									type: 'success',
									message: 'Orden de compra realizada',
								});
								this.loadingConfirm = false;
								this.$store.dispatch('loadCarritoOrdenes');
							} else this.$message.error('Error, ' + result.data.msg);
						} else this.$message.error({ message: 'Orden de compra no realizada' });

						this.loadingConfirm = false;
					});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: 'Operación cancelada',
					});
				});
		},
		empty() {
			return true;
		},
		multiply(a: number, b: number) {
			return a * b;
		},
	},
};
